export function isNotDefined(o) {
    return typeof o === "undefined";
}
export function isDefined(o) {
    return typeof o !== "undefined";
}
